<template>
	<el-select
		v-model="selectValue"
		clearable
		:placeholder="'请选择' + data.name"
		@change="handleChange"
	>
		<el-option
			v-for="item in data.options"
			:key="item.value"
			:label="item.label"
			:value="item.value"
		>
		</el-option>
	</el-select>
</template>

<script>
import { ref } from "@vue/reactivity";
import { inject } from "@vue/runtime-core";
export default {
	props: {
		data: {
			type: Object,
			default() {
				return {};
			},
		},
	},
	setup(props) {
		const updateSearchOption = inject("updateSearchOption");
		const handleSearch = inject("handleSearch");
		let selectValue = ref("");
		const { data } = props;
		const handleChange = (val) => {
			updateSearchOption(data.key, val);
		};

		const handleClear = () => {
			updateSearchOption(data.key, "");
		};

		const handleEnter = () => {
			handleSearch();
		};
		return {
			handleClear,
			handleEnter,
			handleChange,
			selectValue,
		};
	},
};
</script>

<style scoped>
</style>
